<template class="overlay">
  <div class="index">
    <div class="overlay-menu">     
        <div id="projets" class="tablecon"> 
          <div class="row th list">
            <div class="col-12 ta titlecont" >Table of Contents</div>        
          </div> 
           <div  id="table_content">     
            <a @click="turnPage(2)" class="row list" >
                <div class="col-xs-12 col-sm-9">Editors Letter</div>
                <div class="hidden-xs col-sm-3"><span>1</span></div>
            </a>
            <a  @click="turnPage(6)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Masthead</div>
                <div class="hidden-xs col-sm-3">4</div>
            </a>
            <a  @click="turnPage(8)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Contributors</div>
                <div class="hidden-xs col-sm-3">7</div>
            </a>
            <a  @click="turnPage(13)" class="row list"  >
                <div class="col-xs-12 col-sm-9">#womenofempowerment - Alicia Keys</div>
                <div class="hidden-xs col-sm-3">10</div>
            </a>
            <a  @click="turnPage(15)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Diane Von Furstenberg – a video interview	</div>
                <div class="hidden-xs col-sm-3">12</div>
            </a>
            <a  @click="turnPage(17)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Picture Imperfect - a Beatles daughter talks shop	</div>
                <div class="hidden-xs col-sm-3">14</div>
            </a>
            <a  @click="turnPage(26)" class="row list"  >
                <div class="col-xs-12 col-sm-9">She Said, She Said - Tina Brown and her take on media</div>
                <div class="hidden-xs col-sm-3">24</div>
            </a>
            <a  @click="turnPage(32)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Youth Series - Caroline Jenkins</div>
                <div class="hidden-xs col-sm-3">30</div>
            </a>
            <a  @click="turnPage(34)" class="row list"  >
                <div class="col-xs-12 col-sm-9">The Voice - lead singer of the U.K band Texas	</div>
                <div class="hidden-xs col-sm-3">32</div>
            </a>
            <a  @click="turnPage(38)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Power Play - CEO of Barneys</div>
                <div class="hidden-xs col-sm-3">36</div>
            </a>
            <a  @click="turnPage(42)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Out of Africa - Ali Hewson</div>
                <div class="hidden-xs col-sm-3">40</div>
            </a>
            <!-- <a  @click="turnPage(44)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Youth Series: Adam Bennett</div>
                <div class="hidden-xs col-sm-3">44</div>
            </a> -->
            <a  @click="turnPage(48)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Fashion - Eco Park - by Tory Rust</div>
                <div class="hidden-xs col-sm-3">46</div>
            </a>
            <a  @click="turnPage(58)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Skater Gurls Podcast </div>
                <div class="hidden-xs col-sm-3">56</div>
            </a>
            <a  @click="turnPage(60)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Fashion - Skater Gurls - by Stephan Alessi</div>
                <div class="hidden-xs col-sm-3">58</div>
            </a>
            <a  @click="turnPage(62)" class="row list"  >
                <div class="col-xs-12 col-sm-9">We The People - Gloria Steinem</div>
                <div class="hidden-xs col-sm-3">60</div>
            </a>
            <a  @click="turnPage(68)" class="row list"  >
                <div class="col-xs-12 col-sm-9">#womenofepowerment - Amandla Steinberg</div>
                <div class="hidden-xs col-sm-3">66</div>
            </a>
            <a  @click="turnPage(70)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Full Gallop - Cindy Gallop</div>
                <div class="hidden-xs col-sm-3">68</div>
            </a>
            <a  @click="turnPage(76)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Fearless Girl - speaking to the sculptor</div>
                <div class="hidden-xs col-sm-3">74</div>
            </a>
            <a  @click="turnPage(82)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Youth Series - Ashima Shiraishi</div>
                <div class="hidden-xs col-sm-3">80</div>
            </a>
            <a  @click="turnPage(84)" class="row list"  >
                <div class="col-xs-12 col-sm-9">A Tale of Two Sisters - surviving breast cancer	</div>
                <div class="hidden-xs col-sm-3">82</div>
            </a>
            <a  @click="turnPage(92)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Rock of All Ages - teen girls rock on</div>
                <div class="hidden-xs col-sm-3">90</div>
            </a>
            <a  @click="turnPage(94)" class="row list"  >
                <div class="col-xs-12 col-sm-9">‘Four Walls’ music video</div>
                <div class="hidden-xs col-sm-3">92</div>
            </a>
            <a  @click="turnPage(96)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Youth Series - Willow Bennison</div>
                <div class="hidden-xs col-sm-3">94</div>
            </a>
            <a  @click="turnPage(98)" class="row list"  >
                <div class="col-xs-12 col-sm-9">#womenofempowerment - Beyoncé</div>
                <div class="hidden-xs col-sm-3">96</div>
            </a>
            <a  @click="turnPage(100)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Fashion - New Chicks on the Block – by Sophie Elgort</div>
                <div class="hidden-xs col-sm-3">98</div>
            </a>
            <a  @click="turnPage(116)" class="row list"  >
                <div class="col-xs-12 col-sm-9">#womenofempowerment - Christy Turlington Burns</div>
                <div class="hidden-xs col-sm-3">114</div>
            </a>
            <a  @click="turnPage(118)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Stand Tall - Aija Mayrock on bullying</div>
                <div class="hidden-xs col-sm-3">116</div>
            </a>
            <a  @click="turnPage(122)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Youth Series - Sofia D’Angelo </div>
                <div class="hidden-xs col-sm-3">120</div>
            </a>
            <a  @click="turnPage(124)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Pred A Porter - female empowering works of art</div>
                <div class="hidden-xs col-sm-3">122</div>
            </a>
<!--             <a  @click="turnPage(126)" class="row list"  >
                <div class="col-xs-12 col-sm-9">#youthleader - Elle Fanning</div>
                <div class="hidden-xs col-sm-3">124</div>
            </a> -->
            <a  @click="turnPage(130)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Champion of Change - a leading voice for the LGBTQ+</div>
                <div class="hidden-xs col-sm-3">128</div>
            </a>
            <a  @click="turnPage(138)" class="row list"  >
                <div class="col-xs-12 col-sm-9">#womenofempowerment - Debbie Harry</div>
                <div class="hidden-xs col-sm-3">136</div>
            </a>
            <a  @click="turnPage(140)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Wonder Maker - video artist Dara Birnbaum </div>
                <div class="hidden-xs col-sm-3">138</div>
            </a>
            <a  @click="turnPage(148)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Hey ‘Ya - by Brigitte Lacombe </div>
                <div class="hidden-xs col-sm-3">146</div>
            </a>
            <a  @click="turnPage(178)" class="row list"  >
                <div class="col-xs-12 col-sm-9">#womenofempowerment - Ellen Page</div>
                <div class="hidden-xs col-sm-3">176</div>
            </a>
            <a  @click="turnPage(180)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Finding My Melody - singer Juliette describes her work</div>
                <div class="hidden-xs col-sm-3">178</div>
            </a>
            <a  @click="turnPage(184)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Unsung Heroine - homage to Minnie Riperton</div>
                <div class="hidden-xs col-sm-3">182</div>
            </a>
            <a  @click="turnPage(194)" class="row list"  >
                <div class="col-xs-12 col-sm-9">A Simple Plan - meet designer Gabriela Hearst</div>
                <div class="hidden-xs col-sm-3">192</div>
            </a>
            <a  @click="turnPage(200)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Youth Series - Dea Brogaard Thompson</div>
                <div class="hidden-xs col-sm-3">198</div>
            </a>
            <a  @click="turnPage(202)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Maker’s Mark - Dyllan McGee finding her mark</div>
                <div class="hidden-xs col-sm-3">200</div>
            </a>
            <a  @click="turnPage(208)" class="row list"  >
                <div class="col-xs-12 col-sm-9">#womenofempowerment - Indira Gandhi	</div>
                <div class="hidden-xs col-sm-3">206</div>
            </a>
            <a  @click="turnPage(210)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Lone Star - the first female sheriff of Texas</div>
                <div class="hidden-xs col-sm-3">208</div>
            </a>
            <a  @click="turnPage(218)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Beyond Borders - a British woman fights for immigrants rights</div>
                <div class="hidden-xs col-sm-3">216</div>
            </a>
            <a  @click="turnPage(224)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Drawing the Lines - downloadable coloring book</div>
                <div class="hidden-xs col-sm-3">222</div>
            </a>
            <a  @click="turnPage(234)" class="row list"  >
                <div class="col-xs-12 col-sm-9">#womenofempowerment - Iris Apfel</div>
                <div class="hidden-xs col-sm-3">232</div>
            </a>
            <a  @click="turnPage(236)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Web Wonder - Afghanistan female coder</div>
                <div class="hidden-xs col-sm-3">234</div>
            </a>
            <a  @click="turnPage(240)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Youth Series - Rihana Abdulrashid-Davis</div>
                <div class="hidden-xs col-sm-3">238</div>
            </a>
            <a  @click="turnPage(243)" class="row list"  >
                <div class="col-xs-12 col-sm-9">The Female Lead - IBM’s innovator</div>
                <div class="hidden-xs col-sm-3">241</div>
            </a>
            <a  @click="turnPage(248)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Move Over “Bro” Grammer - a lesbian tech company</div>
                <div class="hidden-xs col-sm-3">246</div>
            </a>
            <a  @click="turnPage(252)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Youth Series - Erin Winick</div>
                <div class="hidden-xs col-sm-3">250</div>
            </a>
            <a  @click="turnPage(254)" class="row list"  >
                <div class="col-xs-12 col-sm-9">#womenofempowerment - Jane Fonda</div>
                <div class="hidden-xs col-sm-3">252</div>
            </a>
            <a  @click="turnPage(256)" class="row list"  >
                <div class="col-xs-12 col-sm-9">About Gender Equality by Christiaan Houtenbos</div>
                <div class="hidden-xs col-sm-3">254</div>
            </a>
            <a  @click="turnPage(263)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Leveling the Field - not your typical scientist</div>
                <div class="hidden-xs col-sm-3">261</div>
            </a>
            <a  @click="turnPage(270)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Youth Series - Victoria Pannell  </div>
                <div class="hidden-xs col-sm-3">268</div>
            </a>
            <a  @click="turnPage(272)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Hi, I’m Julia - an autistict girl joins Sesame Street</div>
                <div class="hidden-xs col-sm-3">270</div>
            </a>
            <a  @click="turnPage(276)" class="row list"  >
                <div class="col-xs-12 col-sm-9">#womenofempowerment - Lady Gaga</div>
                <div class="hidden-xs col-sm-3">274</div>
            </a>
            <a  @click="turnPage(278)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Up In the Air - a homage to designer Yohji Yamamoto</div>
                <div class="hidden-xs col-sm-3">276</div>
            </a>
            <a  @click="turnPage(288)" class="row list"  >
                <div class="col-xs-12 col-sm-9">#womenofempowerment - Laverne Cox </div>
                <div class="hidden-xs col-sm-3">286</div>
            </a>
            <a  @click="turnPage(290)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Rock Solid - mining close to the Arctic Circle</div>
                <div class="hidden-xs col-sm-3">288</div>
            </a>
            <a  @click="turnPage(298)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Youth Series - Astronaut Abby</div>
                <div class="hidden-xs col-sm-3">296</div>
            </a>
            <a  @click="turnPage(300)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Keeping It Real - from Pets.com to sustainable fashion</div>
                <div class="hidden-xs col-sm-3">298</div>
            </a>
            <a  @click="turnPage(306)" class="row list"  >
                <div class="col-xs-12 col-sm-9">The Golden Era - supporting artists in Harlem, NY</div>
                <div class="hidden-xs col-sm-3">304</div>
            </a>
            <a  @click="turnPage(312)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Lights, Camera & Action - supporting women in film</div>
                <div class="hidden-xs col-sm-3">310</div>
            </a>          
            <a  @click="turnPage(317)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Grand Jeté - a dancers next move into directing</div>
                <div class="hidden-xs col-sm-3">315</div>
            </a>
            <a  @click="turnPage(320)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Everybody Dance Now - this plus size dance group is making strides</div>
                <div class="hidden-xs col-sm-3">318</div>
            </a>
            <a  @click="turnPage(324)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Fashion video - Pretty Big Movement and Stephen Galloway</div>        
                <div class="hidden-xs col-sm-3">322</div>
            </a>

            <a  @click="turnPage(326)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Simon Says - Parsons  ex dean explains where he is heading next</div>
                <div class="hidden-xs col-sm-3">324</div>
            </a>
            <a  @click="turnPage(332)" class="row list"  >
                <div class="col-xs-12 col-sm-9">#womenofempowerment - Lupita Nyong’o</div>
                <div class="hidden-xs col-sm-3">330</div>
            </a>
            <a  @click="turnPage(336)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Creative Exchange - how this woman founded a creative agency</div>
                <div class="hidden-xs col-sm-3">333</div>
            </a>
            <a  @click="turnPage(342)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Youth Series - Dali Schonfelder</div>
                <div class="hidden-xs col-sm-3">340</div>
            </a>
            <a  @click="turnPage(348)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Starr Power - a singer explains her words</div>
                <div class="hidden-xs col-sm-3">345</div>
            </a>
            <a  @click="turnPage(350)" class="row list"  >
                <div class="col-xs-12 col-sm-9">#womenofempowerment - Melinda Gates</div>
                <div class="hidden-xs col-sm-3">348</div>
            </a>
            <a  @click="turnPage(354)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Underneath It All - a mother daughter’s storytelling</div>
                <div class="hidden-xs col-sm-3">351</div>
            </a>
            <a  @click="turnPage(358)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Youth Series - Ocean Pleasant</div>
                <div class="hidden-xs col-sm-3">356</div>
            </a>
            <a  @click="turnPage(360)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Paint By Number Interview - how a beauty story evolved</div>
                <div class="hidden-xs col-sm-3">358</div>
            </a>

            <a  @click="turnPage(362)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Beauty Story - Paint By Number - by Sølve Sundsbø</div>
                <div class="hidden-xs col-sm-3">360</div>
            </a>
            <a  @click="turnPage(380)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Youth Series - Lena Faske</div>
                <div class="hidden-xs col-sm-3">378</div>
            </a>
            <a  @click="turnPage(382)" class="row list"  >
                <div class="col-xs-12 col-sm-9">#womenofempowerment - Salma Hayek</div>
                <div class="hidden-xs col-sm-3">380</div>
            </a>
            <a  @click="turnPage(384)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Fashion - Shoot and Pointe - by Victor Demarchelier</div>
                <div class="hidden-xs col-sm-3">382</div>
            </a>
            <a  @click="turnPage(402)" class="row list"  >
                <div class="col-xs-12 col-sm-9">#womenofempowerment - Serena Williams</div>
                <div class="hidden-xs col-sm-3">400</div>
            </a>
            <a  @click="turnPage(404)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Fashion - Mirror Mirror - by David Bellemere</div>
                <div class="hidden-xs col-sm-3">402</div>
            </a>
            <a  @click="turnPage(416)" class="row list"  >
                <div class="col-xs-12 col-sm-9">#womenofempowerment - Simone Biles</div>
                <div class="hidden-xs col-sm-3">414</div>
            </a>
            <a  @click="turnPage(418)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Fashion - Freak Le Chic - by Chris Craymer</div>
                <div class="hidden-xs col-sm-3">416</div>
            </a>
            <a  @click="turnPage(430)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Freak Le Chic - 360 Interactive Film</div>
                <div class="hidden-xs col-sm-3">428</div>
            </a>
            <a  @click="turnPage(432)" class="row list"  >
                <div class="col-xs-12 col-sm-9">#womenofmpowerment - Tracee Ellis Ross</div>
                <div class="hidden-xs col-sm-3">430</div>
            </a>
            <a  @click="turnPage(434)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Testimonials</div>
                <div class="hidden-xs col-sm-3">432</div>
            </a>
            <a  @click="turnPage(438)" class="row list"  >
                <div class="col-xs-12 col-sm-9">Thank You </div>
                <div class="hidden-xs col-sm-3">436</div>
            </a>
            
           </div>   
        </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import '@/lib/turn.min.js';
import { mapMutations } from "vuex";

export default {  

    data()  {
        return {
            
        }
    },
    methods: {
        turnPage(num){ 
            $('.flipbook'). turn("page",num) 
            this.setClass(false)             
        },
        ...mapMutations('magazine',[
            'setClass'
        ]), 
        
    },
}
</script>

 <style lang="scss">
/* a .row.list {
    outline: none !important;
    text-decoration: none;
    color: black;
&:hover {
    color: blue;
    cursor:pointer;
    
}
} */

.overlay-menu {
    position: absolute;
    background: white;
    width: 100%;
    height: 100%;
    z-index:999;
    overflow-x: hidden;
    overflow-y: scroll;
    top:0px;
}

#projets .th.row.list div:last-child, #projets a.row.list div:last-child {
    text-align: right;
    font-family: 'CaslonOldFace';
}
#projets .row.list div:first-child {
    display: inline;
    font-family: 'CaslonOldFace';
}
#projets .row.th div {
    font-weight: 600;
    color: rgba(10, 0, 30, .25);
    text-transform: uppercase;
    font-size: .8em;
    letter-spacing: .1em;
    margin-left: -10%;
}

#projets .row.list div {
    font-size: 1em;
    padding-top: .6em;
    padding-bottom: .6em;
    font-weight: 200;
    line-height: 0.6em;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
}
.tablecon {
    padding-left: 25%;
    padding-right: 25%;
    padding-top: 10%;
    padding-bottom: 10%;
    font-family: 'CaslonOldFace';
     a {
        text-decoration: none;
        color: black;
        opacity: .5;
        cursor: pointer;
    }
    a:hover {
        color: black;
        font-weight: 900;
        opacity: 5;
        font-size: 1.2em;
    }
}
.titlecont{
    font-size: x-large !important;
    padding-bottom: 75px !important;
    text-align: center !important;
}



</style>